import axios from 'axios';
export class MetricsApiClient {
  private webApiUrl: string;

  constructor(webApiUrl: string) {
    this.webApiUrl = webApiUrl;
  }

  public sendMetric = (feature: string, element: string, action: string) => {
    const correlationId = '00000000-0000-0000-0000-000000000000';
    const profileId = -1;
    const actionTime = Date.now();
    const url = new URL(
      `/zenousage/recordFeature/host?feature=${feature}&element=${element}&action=${action}&correlationId=${correlationId}&profileId=${profileId}&actionTime=${actionTime}`,
      this.webApiUrl,
    ).toString();

    return axios
      .post(url, {
        widget: 'savi.travellerlanding.webapp',
        hostname: window.location.host,
      })
      .catch(error => error.response);
  };
}
